<template>
    <listTriviaComponent />
</template>

<script>
import listTriviaComponent from "@/views/trivia/pages/list_trivia/components/list_trivia_component.vue"
export default {
    name: "triviaListPage",
    components: {
        listTriviaComponent
    },
}
</script>

<style lang="css" scoped>
</style>
